// Per-area access level (view / edit / manage) for hiding buttons. Provided by Shell from /access/me.
import { createContext, useContext } from "react";

export const AreaLevelContext = createContext({ unrestricted: true, levels: null, pageId: null });
const RANK = { none: 0, view: 1, edit: 2, manage: 3 };

export function useAreaLevel(pageId) {
  const { unrestricted, levels, pageId: current } = useContext(AreaLevelContext);
  const id = pageId || current;
  if (unrestricted || !levels || !id) return "manage";
  return levels[id] || "view";
}

// can("edit") / can("manage") — true when this person's level on the area is at least that.
export function useCan(pageId) {
  const lvl = useAreaLevel(pageId);
  return (need) => RANK[lvl] >= RANK[need];
}
